import { rem, Spacer } from 'design-system';
import Amount from 'design-system/Amount';
import Text from 'design-system/Text';
import ToolTip from 'design-system/ToolTip';
import useStyles from 'hooks/useStyles';
import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import createStyleSheets from 'utils/createStyleSheets';
import links from 'utils/links';
import { isWeb } from '../../../constants';
const strings = {
    rollingIsOnTitle: 'Rolled amount',
    rollingIsOnDescription: 'The rolled amount is the leftover or overspent from your previous period carried into this period. You can reset it anytime by editing your budgets.',
    rollingWasOnTitle: 'Rolling budget was on',
};
export const RollingBudgetStatusTooltip = memo(({ onModalShown, onModalHidden, rolledAmount, currency, defaultAmount, wasRolling, }) => {
    const styles = useStyles(styleSet);
    const renderTitle = useMemo(() => wasRolling ? strings.rollingWasOnTitle : strings.rollingIsOnTitle, [wasRolling]);
    const renderDescription = useMemo(() => wasRolling ? (<View style={styles.flex}>
              <Text TextThin-14 Secondary {...(!isWeb && { centered: true })}>
                {'The leftover or overspent amount from this period was rolled into the next.'}
              </Text>
              <Spacer h={4}/>
              <Text TextThin-14 Secondary {...(!isWeb && { centered: true })}>
                {`The amount shown here was carried over from the previous period’s leftover or overspend. `}
              </Text>
              <Spacer h={4}/>

              <Text Text-14 Primary suppressHighlighting {...(!isWeb && { centered: true })} onPress={() => links.openKnownLink('rollingBudgets')}>
                Learn more
              </Text>

              <View style={styles.container}>
                <View style={styles.textRow}>
                  <Text TextThin-14 Secondary>
                    Default budget:
                  </Text>
                  <Amount NumbersThin-14 Secondary value={{
            value: defaultAmount || 0,
            currency,
        }}/>
                </View>
                <Spacer h={4}/>
                <View style={styles.textRow}>
                  <Text TextThin-14 Secondary>
                    Rolled over from last period:
                  </Text>
                  <Amount NumbersThin-14 showSign Secondary value={{
            value: Number(rolledAmount) || 0,
            currency,
        }}/>
                </View>
              </View>
            </View>) : (strings.rollingIsOnDescription), [
        currency,
        defaultAmount,
        rolledAmount,
        styles.container,
        styles.flex,
        styles.textRow,
        wasRolling,
    ]);
    return (<ToolTip small offset={0} title={renderTitle} subtitle={renderDescription} learnMore={!wasRolling} onPressLearnMore={() => links.openKnownLink('rollingBudgets')} onModalShown={onModalShown} onModalHidden={onModalHidden}/>);
});
const styleSet = createStyleSheets((colors) => ({
    flex: {
        flex: 1,
    },
    container: {
        flex: 1,
        marginTop: rem(16),
        padding: rem(16),
        backgroundColor: colors.background.dark,
        borderRadius: rem(16),
    },
    textRow: {
        flex: 1,
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}));
